<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const stage = computed(() => store.getters['registration/stage']);
const discountMetaData = computed(() => store.getters['registration/discountMetaData']);

const shouldShowBanner = computed(() => {
  return discountMetaData.value && stage.value === 'PAYMENT_INFORMATION'
});
</script>

<template>
  <div
    v-if="shouldShowBanner"
    class="tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-p-4 tw-mb-6 tw-shadow-sm"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
      <div class="tw-flex tw-justify-center tw-gap-3">
        <div
          v-if="discountMetaData && !discountMetaData.error"
          class="tw-flex tw-justify-center tw-items-center tw-gap-3"
        >
          <svg-vue
            icon="icons/coupon"
            class="tw-w-8"
          />

          <div class="tw-bg-[#F3625A] tw-text-white tw-px-4 tw-py-2 tw-rounded tw-font-bold tw-text-sm tw-whitespace-nowrap">
            Coupon Applied
          </div>
          <div class="tw-text-primary-1000 tw-text-sm tw-text-center tw-leading-relaxed tw-font-bold">
            {{ discountMetaData.description }}
          </div>
        </div>

        <div
          v-else
          class="tw-flex tw-items-center tw-gap-3"
        >
          <div class="tw-bg-[#F3625A] tw-text-white tw-px-4 tw-py-2 tw-rounded tw-font-semibold tw-text-sm tw-whitespace-nowrap">
            <span
              v-if="discountMetaData && discountMetaData.error"
              v-html="discountMetaData.error"
            />
            <span v-else>
              Invalid coupon supplied
            </span>
          </div>
          <div class="tw-text-gray-600 tw-text-sm tw-text-center tw-leading-relaxed">
            <span
              v-if="discountMetaData && discountMetaData.message"
              v-html="discountMetaData.message"
            />
            <span
              v-else
              class="tw-text-primary-1000 tw-text-sm"
            >
              The supplied coupon is invalid. Please ensure you have copied the correct link. If you are sure the coupon is
              correct please contact support for further assistance.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

